import {
  ServerActionWidget,
  SPI,
  ActionWidget,
  ActionType,
  ClickResult,
  RuntimeServerAction,
  SubmitValue,
  MessageHub
} from '@kunlun/dependencies';

/**
 * 经销商开票单 - 取消打包 Action Widget
 * 绑定后端 BillingBillCancelPackAction.cancelPack
 */
@SPI.ClassFactory(
  ActionWidget.Token({
    actionType: ActionType.Server,
    name: 'cancelPack',
    model: ['deli.aries.settlement.BillingBillLine']
  })
)
export class CancelPackActionWidget extends ServerActionWidget {
  protected async executeAction(
    action: RuntimeServerAction,
    submitValue: SubmitValue
  ): Promise<ClickResult> {
    const submitValueCopy = { ...submitValue };
    submitValueCopy.records = this.activeRecords ?? [];
    return super.executeAction(action, submitValueCopy);
  }

  protected clickActionAfter(result: ClickResult): Promise<ClickResult> {
    MessageHub.success('取消打包成功');
    return super.clickActionAfter(result);
  }
}
